import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTableComponent, DataColumnType, ICustomTable, ButtonColumnType } from 'lib-base';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetNucleoFamiliar } from '../../../shared/interfaces/sisben/sisben';

@Component({
  selector: 'app-nucleo-familiar-hijos',
  standalone: true,
  imports: [CommonModule, CustomTableComponent],
  template: `
  <custom-table [config]="customTable"></custom-table>
  `
})
export class NucleoFamiliarHijosComponent implements OnInit {
  @Input() hijos: IGetNucleoFamiliar[] = [];

  customTable!: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent!: CustomTableComponent;
  trans: any = {};

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    this.translate().then(
      () => this.configureTable()
    );
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      nombreCompleto: this.translateService.get('common.nombreCompleto'),
      tipoIdentificacion: this.translateService.get('common.tipoIdentificacion'),
      identificacion: this.translateService.get('common.identificacion'),
      vinculo: this.translateService.get('common.vinculo'),
      abrir: this.translateService.get('common.abrir'),
    }));
  }

  private configureTable(): void {
    this.customTable = {
      settings:{
        table:{
          paginator: false
        }
      },
      columns: [
        {
          field: 'nombreCompleto',
          header: this.trans.nombreCompleto,
          dataType: DataColumnType.TEXT,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          }
        },
        {
          field: 'tipoIdentificacion',
          header: this.trans.tipoIdentificacion,
          dataType: DataColumnType.TEXT,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          }
        },
        {
          field: 'identificacion',
          header: this.trans.identificacion,
          dataType: DataColumnType.TEXT,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          }
        },
        {
          field: 'vinculo',
          header: this.trans.vinculo,
          dataType: DataColumnType.TEXT,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          }
        },
        {
          field: 'abrir',
          header: '',
          label: this.trans.abrir,
          icon: 'pi pi-folder-open',
          class: 'button-edit p-button-outlined pt-2 pb-2',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: IGetNucleoFamiliar) => this.openProfile(data)
        }
      ]
    } as ICustomTable;

    setTimeout(() => {
      this.customTableComponent.data = this.hijos;
    }, 1);
  }

  private openProfile(data: IGetNucleoFamiliar): void {
    window.open(`#/sisben/perfil/${data.id}`, '_blank');
  }
}
